import * as types from '../constants/dashboardConstants';
import { CommonActions } from './commonActions';

export class DashboardActions {

  //let flagCheck =true;
  // Auth
  static isLoaded(globalState) {
    return globalState.auth && globalState.auth.loaded;
  }

  static showLoadingIndicator() {
    return { type: types.LOADING_ON };
  }

  static updateCanLogout() {
    return { type: types.UPDATE_CAN_LOGOUT };
  }

  static stopLoadingIndicator() {
    return { type: types.LOADING_OFF };
  }

  // Get Widget layout on dashboard initially
  static isThemeLoaded(globalState) {
    return globalState.dashboardRoot.dashboard && globalState.dashboardRoot.dashboard.loaded;
  }

  static loadWidgetTheme() {
    return (dispatch) => {
      dispatch(CommonActions.handleAPICall('', '/widget_theme', 'LOAD_WIDGET', 'GET'))
    }
    // return {
    //   types: [
    //     types.LOAD_WIDGET, types.LOAD_WIDGET_SUCCESS, types.LOAD_WIDGET_FAILURE
    //   ],
    //   promise: (client) => client.get('/widget_theme', {})
    // };
  }
  static getTempList() {
    return (dispatch) => {
      dispatch(CommonActions.handleAPICall('', '/template_list', 'LOAD_TEMPLIST', 'GET'))
    }
    // return {
    //   types: [
    //     types.LOAD_TEMPLIST, types.LOAD_TEMPLIST_SUCCESS, types.LOAD_TEMPLIST_FAILURE
    //   ],
    //   promise: (client) => client.get('/template_list', {})
    // };
  }
  // Change dashboard to edit mode
  static editDashboard(clickedEdit) {
    return { type: types.EDIT_DASHBOARD, clickedEdit };
  }

  // Changing the layout of widgets
  static changeWidgetlayout(dashboardlayout, layout, deleteWidgetKey, flag) {
    //if(flagCheck===true){
    layout.map((item) => {
      let str = item.i;
      let id = item.i;
      str = str.substring(0, str.indexOf('-'));
      if (str === "Trade" || str === "Chart") {
        dashboardlayout.map((item1) => {
          let str1 = item1.i;
          str1 = str1.substring(0, str1.indexOf('-'));
          if (str1 === "Trade" && item1.i === id) {
            item.cmdtyPair = item1.cmdtyPair;
          }
          if (str1 === "Chart" && item1.i === id) {
            item.cmdtyPair = item1.cmdtyPair;
            item.chartData = item1.chartData;
          }
        })
      }
    });
    return { type: types.SUCCESS_CHANGE_WIDGETS, layout, deleteWidgetKey };
  }

  //Set Default commodity
  static defaultComdtyPair(layout, cmdtyPair) {
    return { type: types.DEFAULT_COMMODITYPAIR, layout, cmdtyPair };
  }
  // Save user changes on widgets
  static saveWidgetActions(layout, tradeBookColumns, tempName, isDefault, saveType, modal) {
    tradeBookColumns.outstngBmOrderColumns[0].cell = "";
    tradeBookColumns.outstngLmtOrderColumns[0].cell = "";
    tradeBookColumns.lmtOrderColumns[0].cell = "";
    tradeBookColumns.bmOrderColumns[0].cell = "";
    const value = JSON.stringify({ "tmplData": layout, "tradeBookData": tradeBookColumns });
    const tempname = tempName;
    const isDef = isDefault;
    const savetype = saveType;
    const randomNo = Math.floor((Math.random() * 10) + 1);
    let data = {
      value: value,
      tempname: tempname,
      isDef: isDef,
      savetype: savetype
    }
    return (dispatch) => {
      dispatch(CommonActions.handleAPICall(data, '/widget_theme', 'SAVE_WIDGET_ACTIONS', 'POST', { layout, randomNo, modal }));
    }
    // return {
    //   types: [
    //     types.SAVE_WIDGET_ACTIONS, types.SAVE_WIDGET_ACTIONS_SUCCESS, types.SAVE_WIDGET_ACTIONS_FAILURE
    //   ],
    //   promise: (client) => client.post('/widget_theme', {
    //     data: {
    //       value,
    //       tempname,
    //       isDef,
    //       savetype
    //     }
    //   }),
    //   layout,randomNo
    //  };
  };

  // Delete widgets in dashboard
  static deleteWidget(keyValue) {
    return { type: types.SUCCESS_DELETION, keyValue };
  }

  // Add widget to dashboard
  static addWidget(widget, layoutAdd) {
    return { type: types.ADD_SAMPLE_WIDGET, widget, layoutAdd };
  }

  // Commodity selection in trade panel
  static cmdtySelection(isCmdtySelected) {
    return { type: types.IS_CMDTY_SELECTED, isCmdtySelected };
  }

  // Hide popup
  static hidePopup() {
    return { type: types.HIDE_POPOUT };
  }
  static layoutChanged(layoutCount) {
    return { type: types.LAYOUT_CHANGE_STATUS, layoutCount };
  }
  //update tradeBook Columns
  static updateTrdBookCols(updatedTrdCols) {
    return { type: types.UPDATE_TRADEBOOK_COLUMNS, updatedTrdCols };
  }

  //setting modal
  static handleSettingModal(status) {
    return {
      type: types.HANDLE_SETTING_MODAL,
      status
    };
  }

  //save settings
  static saveSettings(DefaultACCod, isInstantValue, isTrdInstant, storetradeqty, showStockPrc, classname) {
    var data = {
      "AC": DefaultACCod,
      "isInstant": isInstantValue
    }
    return (dispatch) => {
      //types:[types.SAVE_SETTING,types.SAVE_SETTING_SUCCESS,types.SAVE_SETTING_FAILURE],
      dispatch(CommonActions.handleAPICall(data, '/saveTrdSettings', 'SAVE_SETTING', 'POST',
        { isTrdInstant, storetradeqty, showStockPrc, classname }));
      //isTrdInstant,storetradeqty,showStockPrc,classname
    };
  }

  static toggleColumn(columns) {
    return { type: types.TOGGLE_COLUMN, columns }
  }

  static loadTemplate(tmpldata) {
    const layout = JSON.parse(tmpldata);
    return { type: types.LOAD_TEMPLATE, layout };
  }
  static handlebenchmarkModal(BMpopup) {
    return {
      type: types.HANDLE_BM_MODAL,
      BMpopup
    };
  }
  static handleLimitModal(LMTPopup) {
    return {
      type: types.HANDLE_LMT_MODAL,
      LMTPopup
    };
  }
  static addwidgetflag(addWidgetmodal) {
    return {
      type: types.CHANGE_ADDWIDGETFLAG,
      addWidgetmodal
    };
  }
  static layoutflag(status) {
    return {
      type: types.HANDLE_LAYOUT_FLAGMODAL,
      status
    };
  }
  static loadTemplateFlag(flag) {
    return {
      type: types.LOAD_TEMP_FLAG,
      flag
    };
  }
  // For changing commodity pair
  static changeCmdyPair(cmdyPair, currentId, layout, key) {
    return {
      type: types.CHANGE_COMMDTY,
      cmdyPair,
      currentId,
      layout,
      key,
    };
  }
  // For changing commodity pair of chart
  static saveChartoptions(cmdyPair, currentId, layout, chartData) {
    return {
      type: types.CHANGE_CHART_COMMDTY,
      cmdyPair,
      currentId,
      chartData,
      layout
    };
  }
  static setTooltipFlag(flag) {
    return {
      type: types.ENABLE_TOOLTIP,
      flag
    };
  }

  static closeLimitOrdModal(flag) {
    return {
      type: types.CHANGE_LMTORD_FLAG,
      flag
    };
  }
  static setBmkOrdModalFlag(flag) {
    return {
      type: types.CHANGE_BMKORD_FLAG,
      flag
    };
  }

  static clearLayoutMsg(flag) {
    return {
      type: types.CLEAR_SAVE_TEMP_MSG,
      flag
    };
  }
  //Delete selected template
  static deleteSelectedTemplate(layout, tempname, isDef, savetype) {
    let data = {
      layout,
      tempname,
      isDef,
      savetype
    }
    return (dispatch) => {
      // types: [
      //   types.DELETE_TEMPLATE, types.DELETE_TEMPLATE_SUCCESS, types.DELETE_TEMPLATE_FAILURE
      // ],
      dispatch(CommonActions.handleAPICall(data, '/widget_theme', 'DELETE_TEMPLATE', 'POST'))
    };
  }

  static isAllApiLoaded(flag) { //console.log(" isAllApiLoaded "+flag);
    return {
      type: types.IS_INITIAL_API_LOADED,
      flag
    };
  }
  static resetDashState() {
    return {
      type: types.RESET_DASH_STATE
    }
  }
}
